/**
 *
 * Convert base64 encoded file to Uint8Array
 *
 * @param {string} base64
 * @return {Uint8Array}
 *
 */
function base64ToBytesArray(base64) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}

export { base64ToBytesArray };
